export class Bonus {
    constructor(scene) {
        this.scene = scene;
        this.bonusContainer = this.scene.add.container();
        this.timers = [];
    }

    init(callback) {
        this.callback = callback;

        if(this.scene.slots.spinStarted) {
            return;
        }

        this.playBonusText();
    }

    reset() {
        for(const [ timerIndex, timer ] of Object.entries(this.timers)) {
            timer.remove();
            delete this.timers[timerIndex];
        }

        for (const sprite of this.bonusContainer.getAll()) {
            if(sprite.tween && sprite.tween.isPlaying()) {
                sprite.tween.remove();
            }

            if(sprite.anims) {
                if(sprite.anims.isPlaying) {
                    sprite.anims.pause();
                }
            }

            sprite.destroy();
        }

        this.bonusContainer.removeAll();

        if(this.winAmountContainer) {
            this.winAmountContainer.destroy();
        }

        let winningAmount = this.scene.winningsContainer.getByName('win_amount');
        let totalWin = this.scene.winningsContainer.getByName('total_win');

        if(winningAmount) {
            winningAmount.destroy();
        }

        if(totalWin) {
            totalWin.destroy();
        }

        this.doCallback();
    }

    doCallback() {
        if(this.callback) {
            this.callback();
        }

        this.callback = undefined;
    }

    playBonusText() {
        let bonus = this.scene.add.sprite(0, 0, 'freespins').setOrigin(0.5, 0.5);
        const destination = this.scene.slots.frame.y - 50;
        bonus.y = -(bonus.height);
        bonus.setScale(0.8);


        const fader = this.scene.slots.reelsContainer.getByName(this.scene.slots.symbolsFade);
        fader.alpha = 1;
        this.scene.slots.reelsContainer.bringToTop(fader);

        this.bonusContainer.add(bonus);
        this.scene.sound.play('freespins');
        bonus.tween = this.scene.tweens.add({
            targets: [bonus],
            y: destination,
            ease: 'Power0',
            duration: 300,
            onComplete: () => {
                let freeSpinsAmount = String(this.scene.request.scenario.freespins.total);
                let pos_x = bonus.x;

                for (let i = 0; i < freeSpinsAmount.length; i++) {
                    let amount = this.scene.add.sprite(pos_x + i * 100, 0, freeSpinsAmount[i]).setOrigin(0.5, 0.5);

                    if(freeSpinsAmount.length > 1) {
                        amount.x -= amount.width / 2;
                    }

                    amount.y = bonus.y + bonus.height / 2 + amount.height / 2 - 10;
                    amount.setScale(0);
    
                    this.bonusContainer.add(amount);
    
                    amount.tween = this.scene.tweens.add({
                        targets: [amount],
                        scale: 1,
                        ease: 'Back',
                        duration: 400
                    });    
                }

                bonus.tween = this.scene.tweens.add({
                    targets: [bonus],
                    scale: 1,
                    ease: 'Power0',
                    duration: 200,
                    yoyo: true,
                    onComplete: () => {
                        let timer = this.scene.time.delayedCall(500, () => {
                            this.reset();
                        }, {}, this);
                        
                        this.timers.push(timer);
                    }
                });
            }
        });
    }


    after(callback) {
        this.callback = callback;

        if(this.scene.slots.spinStarted) {
            return;
        }

        this.scene.sound.play('Big');

        this.scene.slots.changeOpacityOfSymbols(0);
        this.scene.slots.changeOpacityOfSymbols(1, true);
        this.scene.symbolsFader();

        this.scene.winningsContainer.alpha = 1;

        let winningAmount = this.scene.request.amountWon;

        this.winAmountContainer = this.scene.winning.createWinningFromSprites('0.00', 0.7);
        this.winAmountContainer.x = this.scene.slots.frame.x;
        this.winAmountContainer.y = this.scene.slots.frame.y + 90;

        let totalWin = this.scene.add.sprite(this.winAmountContainer.startX, (this.winAmountContainer.y - this.winAmountContainer.height) - 10, 'total_win').setOrigin(0.5, 0.5);

        this.winAmountContainer.name = 'win_amount';
        this.winAmountContainer.setScale(0);

        totalWin.name = 'total_win';
        totalWin.setScale(0);

        this.scene.winningsContainer.add(this.winAmountContainer);
        this.scene.winningsContainer.add(totalWin);

        this.winAmountContainer.tween = this.scene.tweens.add({
            targets: [this.winAmountContainer, totalWin],
            scale: 1,
            ease: 'Back',
            duration: 300,
            onComplete: () => {
                let timeout = 0;
                let step = winningAmount / (this.scene.amountWonStep);
                let last = false;
                let currentAmount = 0;

                while(currentAmount < winningAmount) {
                    currentAmount += step;

                    if(currentAmount > winningAmount) {
                        currentAmount = winningAmount;
                    }

                    if(currentAmount === winningAmount) {
                        last = true;
                    }

                    let timer = this.scene.time.delayedCall(timeout, this.setAmountText, [currentAmount, last, callback, false], this);

                    this.scene.winning.timers.push(timer);
                    timeout += this.scene.amountWonTimeout;
                }
            },
        }); 

        this.scene.winning.tweenTimers.push(this.winAmountContainer.tween);
    }

    setAmountText(amount, last, callback) {
        amount = General.format_currency(amount).replace(Config.currency.symbol, '');
        this.scene.sound.play('coin');

        let totalWin = this.scene.winningsContainer.getByName('total_win');
        
        let startY = this.winAmountContainer.y;
        this.winAmountContainer.destroy();

        this.winAmountContainer = this.scene.winning.createWinningFromSprites(amount, 0.7);
        this.winAmountContainer.x = this.scene.slots.frame.x;
        this.winAmountContainer.y = startY;
        this.scene.winningsContainer.add(this.winAmountContainer);

        if(last) {
            const tween = this.scene.tweens.add({
                targets: [this.scene.winningsContainer],
                alpha: 0,
                ease: 'Power0',
                duration: this.scene.amountWonFadeInSpeed,
                yoyo: 0,
                repeat: 0,
                delay: 4 * this.scene.amountWonFadeInSpeed,
                onComplete: () => {
                    if(callback) {
                        this.scene.destroyWinningOnPayline();
                        this.scene.destroySymbolsFader();
                        this.scene.slots.changeOpacityOfSymbols(1);
                        this.winAmountContainer.destroy();
                        totalWin.destroy();
                        callback();
                    }
                },
            });

            this.scene.winning.tweenTimers.push(tween);
        }
    }
}